import styled from 'styled-components';

export const StyledContainer = styled.div`

`;

export const StyledImgSection = styled.a`
 
`;